// useLoot.js
import { useState, useEffect } from 'react';

export function useLoot() {
  const [loot, setLoot] = useState([]);
  useEffect(() => {
    fetch('/wp-json/wp/v2/pfandpirat_loot?_embed&acf_format=standard&per_page=100')
      .then(res => res.json())
      .then(setLoot);
  }, []);
  return loot;
}
